import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListService, PagedResultDto } from '@abp/ng.core';
import {
  GetInspectionsInput,
  InspectionDetailsDto,
  InspectionState,
} from '@proxy/servicing-service/inspections';
import { RecurrenceType } from '@proxy/servicing-service/inspection-types/recurrence-type.enum';
import { Router } from '@angular/router';
import fileDownload from 'js-file-download';
import { CertService } from '@proxy/cert-report-service/certs/cert.service';
import { AssetDetailsDto, AssetService } from '@proxy/register-service/assets';
import { CategoryService } from '@proxy/register-service/categories';
import { EventTypeDefinition } from '@proxy/servicing-service/inspection-types';
import { InspectionService } from '@proxy/servicing-service/inspections/inspection.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-current-events',
  templateUrl: './current-events.component.html',
  styleUrls: ['./current-events.component.scss'],
})
export class CurrentEventsComponent implements OnInit {
  @Input() asset: AssetDetailsDto;
  @Input() isPageTemporary: boolean = false;
  @Input() isAssetDetailsPage = false;
  currentEventsData: PagedResultDto<InspectionDetailsDto> = {
    items: [],
    totalCount: 0,
  };
  selected?: InspectionDetailsDto;
  RecurrenceType = RecurrenceType;
  filters = {} as GetInspectionsInput;
  isModalBusy = false;
  isModalOpen = false;
  constructor(
    public readonly router: Router,
    public readonly list: ListService,
    public readonly service: InspectionService,
    public readonly assetService: AssetService,
    public readonly categoryService: CategoryService,
    private readonly certService: CertService,
    private readonly inspectionService: InspectionService
  ) {}

  ngOnInit() {
    this.filters.state = InspectionState.Draft;

    this.inspectionService
      .getList({
        ...this.filters,
        assetId: this.asset.id,
        isHistorical: false,
        maxResultCount: 100,
        state: InspectionState.Approved,
        eventType: EventTypeDefinition.STANDARD,
      })
      .pipe(tap(d => (this.currentEventsData = d)))
      .subscribe();
  }

  onView(record: InspectionDetailsDto) {
    this.router.navigate(['/inspections/details'], {
      queryParams: { id: record.id, assetId: record.assetId, typeId: record.typeId },
    });
  }

  onGetReport(record: InspectionDetailsDto) {
    this.certService.getCert(record.id).subscribe(resp => {
      fileDownload(resp.data, resp.fileName, resp.contentType);
    });
  }

  onRepeat(record: InspectionDetailsDto) {
    this.router.navigate(['/inspections/create'], {
      queryParams: { assetId: record.assetId, typeId: record.typeId },
    });
  }
}
